import React from "react";

import "./example.css";

const SANDBOX_URL = "https://codesandbox.io/s/q8xw163vr6?";

const defaults = {
  fontsize: 14,
  view: "editor",
};

function qs(params) {
  const result = [];
  for (const [name, value] of Object.entries(params)) {
    switch (typeof value) {
      case "number":
      case "string":
        result.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
        break;
      case "boolean":
        value && result.push(encodeURIComponent(name));
        break;
      default:
        continue;
    }
  }
  return result.join("&");
}

export function SandboxSourceLink({ filepath, size = 24, children, ...props }) {
  const url = `${SANDBOX_URL}${qs({ ...defaults, module: filepath })}`;
  return (
    <a {...props} href={url}>
      {React.Children.count(children) === 0 ? (
        <img
          alt="Example Source at Sandbox.io"
          height={size}
          width={size}
          src="https://unpkg.com/simple-icons@latest/icons/codesandbox.svg"
        />
      ) : (
        children
      )}
    </a>
  );
}

export function CodesandboxBlock({
  className,
  iconSize,
  filepath,
  children,
  ...props
}) {
  return (
    <div className={className} style={{ position: "relative" }}>
      <SandboxSourceLink
        filepath={filepath}
        size={iconSize}
        target="blank"
        style={{
          position: "absolute",
          top: "12px",
          right: "12px",
        }}
      />
      {children}
    </div>
  );
}

function toAnchor(text) {
  return text.toLowerCase().replace(/\W+/g, "-");
}

export function Example({ title, desc, filepath, demo }) {
  return (
    <section className="exampleBlock">
      <div className="exampleBlock-desc">
        <h2>{title}</h2>
        <a name={toAnchor(title)} />
        {desc}
      </div>
      <div className="exampleBlock-demo">
        {filepath ? (
          <SandboxSourceLink
            filepath={filepath}
            className="exampleBlock-sourceButton"
            target="blank"
          />
        ) : null}
        {demo()}
      </div>
    </section>
  );
}

export function Compare({ children }) {
  return <div className="exampleBlock-compare">{children}</div>;
}

export function CompareGroup({ title, children }) {
  return (
    <div className="exampleBlock-compareGroup">
      <h3 className="exampleBlock-compareGroupLegend">
        <code>{title}</code>
      </h3>
      {children}
    </div>
  );
}

Compare.Group = CompareGroup;
